// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"logo-dribbble"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M16.5462 20.35C15.5056 13.9506 12.6605 7.91406 8.40422 3.025M21.7 12.4598C20.5165 12.1595 19.2769 12 18 12C16.7181 12 15.4738 12.1607 14.2861 12.4633C10.5233 13.4217 7.32879 15.8028 5.30913 19M2.3 10.9984C8.55525 10.9327 14.3188 8.81591 18.95 5.28857M12 2C17.5228 2 22 6.47715 22 12C22 17.5229 17.5229 22 12 22C6.47716 22 2 17.5229 2 12C2 6.47714 6.47715 2 12 2Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-logo-dribbble')
export default class LogoDribbbleIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-dribbble',
    }
  }
}
